const Mixpanel = require('mixpanel');
const mixpanel = Mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN, {
  keepAlive: false
});

// Mixpanel geolocates from this when the caller has no coordinates. Fetched directly rather than
// through the `ipify2` package, whose only job was this one call and which dragged in axios 0.21.4
// (2021) with an unfixed CSRF advisory, into the browser bundle.
const fetchClientIp = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    if (!response.ok) return null;
    const body = await response.json();
    return body.ip || null;
  } catch (e) {
    // Analytics must never break the page. ipify2 threw on failure and this is awaited inside
    // component handlers, so an outage could surface as an unhandled rejection mid-interaction.
    return null;
  }
};

export const logMixPanelEvent = async (event, options, coordinates = null) => {
  if (coordinates != null) {
    options['$latitude'] = coordinates.latitude;
    options['$longitude'] = coordinates.longitude;
  } else {
    const ip = await fetchClientIp();
    // Omit the key entirely rather than sending null, which Mixpanel would treat as a value.
    if (ip) options['ip'] = ip;
  }
  mixpanel.track(event, options);
};

export const mixPanelEvent = {
  pageView: 'page view',
  chooseHotel: 'choose hotel',
  searchLocation: 'search location',
  searchLocationNoResults: 'search location no results',
  destinationSearchBar: 'destination search bar',
  breadCrumbHome: 'bread crumb home',
  mapView: 'map view',
  filtersMenu: 'filters menu',
  privacyCloseMenu: 'privacy close menu',
  privacyAdjustSettings: 'privacy adjust settings',
  privacyCookiePage: 'privacy cookie page',
  locationViewMore: 'location view more',
  hotelEvents: {
    hotelFilterEvents: {
      starRating: 'star rating',
      brands: 'hotel brands filter',
      freeCancelation: 'free cancellation filter',
      breakFast: 'break fast filter',
      distance: 'distance filter',
      resetFilter: 'reset filter',
      applyFilter: 'apply filter'
    },
    viewMoreHotels: 'view more hotels',
    hotelCardClck: 'hotel card',
    hotelDetailEvents: {
      roomFacilities: 'room facilities',
      roomRooms: 'room rooms',
      roomPhotos: 'room photos',
      roomOverview: 'room overview',
      viewMoreFaclities: 'view more facilities',
      detailsShowMore: 'hotel details show more',
      guestSelector: 'guest calculator',
      checkInOutCalender: 'check in out calender',
      verifyEmail: 'verify email',
      addCar: 'add car',
      saveCar: 'save car',
      roomsSeeRooms: 'rooms see rooms '
    },
    hotelRoomEvents: {
      roomMoreDetails: 'room more details',
      roomChoose: 'room choose'
    }
  },
  footerEvents: {
    privacyPolicy: 'privacy policy',
    cookies: 'cookies',
    termsAndCoditions: 'terms and conditions',
    AcceptableUsePolicy: 'acceptable use policy',
    twitter: 'social twitter',
    facebook: 'social facebook',
    instagram: 'social instagram',
    linkedIn: 'social linkedin'
  },
  accountConfirmationEvents: {
    accountConfirmation: 'account confirmation',
    accountConfirmationClose: 'close account confirmation'
  },
  cartOptions: {
    basketRemoved: 'basket removed',
    basketRequest: 'basket request'
  }
};
